module.exports = __webpack_public_path__ + "static/team-member-mobile-1e7a76a81142af69fd27cf1c47a1becf.jpg";